import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { independenceMOConfig } from "./data";

export default function IndependenceMOPage() {
  return <CityPageTemplate config={independenceMOConfig} />;
}